import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';

export const WarningThin = (props: IconProps): JSX.Element => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20" {...props}>
      <path
        d="M21.421 19.6849H0.579384C0.373284 19.6849 0.183393 19.5761 0.0791847 19.3978C-0.0250236 19.2195 -0.0261815 19.0006 0.0745532 18.8212L10.4954 0.295257C10.5984 0.113471 10.7906 0 11.0002 0C11.2098 0 11.402 0.112313 11.505 0.295257L21.9259 18.8212C22.0266 19.0006 22.0243 19.2195 21.9212 19.3978C21.8182 19.5761 21.6271 19.6849 21.421 19.6849ZM1.56936 18.5271H20.4311L11.0002 1.76112L1.56936 18.5271Z"
        fill="currentColor"
      />
      <path
        d="M11.0003 13.8955C10.6807 13.8955 10.4214 13.6361 10.4214 13.3165V7.52718C10.4214 7.20761 10.6807 6.94824 11.0003 6.94824C11.3199 6.94824 11.5793 7.20761 11.5793 7.52718V13.3165C11.5793 13.6361 11.3199 13.8955 11.0003 13.8955Z"
        fill="currentColor"
      />
      <path
        d="M11.0003 17.3695C10.6807 17.3695 10.4214 17.1101 10.4214 16.7905V15.6326C10.4214 15.3131 10.6807 15.0537 11.0003 15.0537C11.3199 15.0537 11.5793 15.3131 11.5793 15.6326V16.7905C11.5793 17.1101 11.3199 17.3695 11.0003 17.3695Z"
        fill="currentColor"
      />
    </Icon>
  );
};
